export default __webpack_public_path__ + "static/BigData_Branco-e51f58157f8a18a1ec310574a3907e67.png";